import { WinnerCheckInStatus } from "../../models/winnerCheckInStatus";
import { Button } from "../common/button";
import { useEffect, useState } from "react";
import { twclsx } from "../../utils/cssUtil";
import { useTranslation } from "react-i18next";
import { WinnerIdInfo } from "../../models/winnerIdInfo";

export function UserListWithCheckBox({
  title,
  list,
  onAction,
  loading,
}: {
  title: string;
  list?: WinnerCheckInStatus[];
  onAction?: (selected: WinnerIdInfo[]) => void;
  loading?: boolean;
}) {
  const { t } = useTranslation();
  const [selected, setSelected] = useState(new Array<WinnerIdInfo>());
  const listOfExceptNoShow = list?.filter((e) => !e.isNoShow);
  useEffect(() => {
    setSelected([]);
  }, [list]);

  const onSelect = (winner: WinnerCheckInStatus, checked: boolean) => {
    if (checked) {
      setSelected([...selected, winner]);
    } else {
      setSelected(selected.filter((e) => e.winnerId !== winner.winnerId));
    }
  };
  const onSelectAll = (checked: boolean) => {
    if (checked) {
      setSelected(
        listOfExceptNoShow?.map((e) => new WinnerIdInfo(e.fanId, e.winnerId)) ||
          [],
      );
    } else {
      setSelected([]);
    }
  };
  const disable = list?.every((userInfo) => userInfo.isNoShow);

  return (
    <div className={"bg-base-300 rounded-md p-5"}>
      <div className={"text-lg mb-2 font-semibold flex justify-between"}>
        <span
          className={"my-auto"}
        >{`${title} (${t("eventdetail_checkincount_person", { count: list?.length })})`}</span>
        <label
          className={twclsx("label", onAction ? "cursor-pointer" : "invisible")}
        >
          <input
            type={"checkbox"}
            className={twclsx("checkbox", !disable && "checkbox-primary")}
            onChange={(element) => {
              onAction && onSelectAll(element.target.checked);
            }}
            checked={
              !disable &&
              !!list?.length &&
              selected.length === listOfExceptNoShow?.length
            }
            disabled={!list?.length || disable}
          ></input>
          <span className={"ml-2 label-text"}>
            {t("notcheckedin_checkall")}
          </span>
        </label>
      </div>
      {list?.length ? (
        list?.map((userInfo) => {
          return (
            <label
              key={userInfo.winnerId}
              className={twclsx(
                "label justify-start gap-4",
                onAction && "cursor-pointer",
              )}
            >
              <input
                type={"checkbox"}
                className={twclsx(
                  "checkbox checkbox-primary",
                  (!onAction || userInfo.isNoShow) && "invisible",
                )}
                onChange={(element) => {
                  onAction &&
                    !userInfo.isNoShow &&
                    onSelect(userInfo, element.target.checked);
                }}
                checked={selected.some(
                  (e) =>
                    e.winnerId === userInfo.winnerId &&
                    e.fanId === userInfo.fanId,
                )}
              />
              <span className={"label-text"}>
                {t("userdetail_userinfo_numbering", {
                  numbering: userInfo.orderNumber,
                })}
              </span>
              {userInfo.isNoShow && (
                <label className={"badge badge-sm badge-error"}>
                  {t("notcheckedin_absent_badge")}
                </label>
              )}
            </label>
          );
        })
      ) : (
        <p className={"text-center p-5"}>{t("notcheckedin_noresult")}</p>
      )}
      {!!onAction && (
        <Button
          className={twclsx(
            "w-full mt-3",
            (list?.length === 0 || selected.length === 0 || disable) &&
              "btn-disabled",
          )}
          onClick={() => {
            !!onAction && onAction(selected);
          }}
          loading={loading}
        >
          {t("notcheckedin_absentsubmit")}
        </Button>
      )}
    </div>
  );
}
